import { useState } from "react";
import { toast } from "sonner";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { api, formatError } from "../../lib/api";

export function thisMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export async function registerPayment(memberId, method, paidOn) {
  try {
    await api.post(`/admin/members/${memberId}/payments`, { method, paid_on: paidOn || undefined });
    toast.success("Pagamento registrado · +30 dias");
    return true;
  } catch (err) {
    toast.error(formatError(err));
    return false;
  }
}

export function RegisterPaymentForm({ memberId, onDone }) {
  const [method, setMethod] = useState("pix");
  const [paidOn, setPaidOn] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit() {
    setBusy(true);
    if (await registerPayment(memberId, method, paidOn)) {
      setPaidOn("");
      onDone();
    }
    setBusy(false);
  }

  return (
    <div className="flex gap-2 flex-wrap items-center" data-testid="register-payment-form">
      <Input type="date" max={new Date().toLocaleDateString("en-CA")} value={paidOn} onChange={(e) => setPaidOn(e.target.value)} className="w-40" title="Data do pagamento (vazio = hoje)" data-testid="pay-date" />
      <Select value={method} onValueChange={setMethod}>
        <SelectTrigger className="w-36" data-testid="pay-method"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="pix">Pix</SelectItem>
          <SelectItem value="card">Cartão</SelectItem>
          <SelectItem value="dinheiro">Dinheiro</SelectItem>
        </SelectContent>
      </Select>
      <Button disabled={busy} onClick={submit} className="bg-[#166534] hover:bg-[#14532d] hover:text-white text-white" data-testid="pay-submit">
        Registrar R$ 30,00 (+30 dias)
      </Button>
    </div>
  );
}
